(function () {
  var allMainSlidesData = null;
  var galleryBuilt = false;
  var currentVisibleList = [];
  var currentIndex = 0;
  var customImgEl = null;

  function getAllMainSlidesData() {
    if (!allMainSlidesData) {
      var slides = Array.prototype.slice.call(document.querySelectorAll('.product-main-slide'));
      allMainSlidesData = slides.map(function (el) {
        var img = el.querySelector('img');
        return {
          id: el.getAttribute('data-media-id'),
          isUniversal: el.hasAttribute('data-combo-universal'),
          color: el.getAttribute('data-combo-color'),
          style: el.getAttribute('data-combo-style'),
          src: img ? (img.currentSrc || img.src) : '',
          srcset: img ? img.getAttribute('srcset') : '',
          sizes: img ? img.getAttribute('sizes') : '',
          alt: img ? img.alt : ''
        };
      });
    }
    return allMainSlidesData;
  }

  function normalize(str) {
    return (str || '').toString().trim().toLowerCase();
  }

  function computeVisibleList(colorVal, styleVal) {
    var all = getAllMainSlidesData();
    return all.filter(function (item) {
      if (item.isUniversal) return true;
      if (item.color !== null) {
        return colorVal.indexOf(item.color) !== -1 && styleVal.indexOf(item.style) !== -1;
      }
      return true;
    });
  }

  function applyThumbFilter(visibleIds) {
    var thumbContainer = document.querySelector('.product__thumbs--scroller');
    if (!thumbContainer) return;
    var visibleSet = {};
    visibleIds.forEach(function (id) { visibleSet[id] = true; });

    Array.prototype.slice.call(thumbContainer.querySelectorAll('.product__thumb-item')).forEach(function (el) {
      var id = el.getAttribute('data-media-id');
      el.classList.toggle('combo-hidden', !visibleSet[id]);
    });
  }

  function showImage(index) {
    if (!customImgEl || !currentVisibleList.length) return;
    if (index < 0) index = currentVisibleList.length - 1;
    if (index >= currentVisibleList.length) index = 0;
    currentIndex = index;

    var item = currentVisibleList[currentIndex];
    if (item.srcset) {
      customImgEl.setAttribute('srcset', item.srcset);
    } else {
      customImgEl.removeAttribute('srcset');
    }
    if (item.sizes) customImgEl.setAttribute('sizes', item.sizes);
    customImgEl.src = item.src;
    customImgEl.alt = item.alt || '';
  }

  function buildGallery(mainContainer) {
    if (galleryBuilt) return;
    var wrapper = mainContainer.closest('.product__main-photos') || mainContainer.parentElement;
    if (!wrapper) return;

    mainContainer.style.display = 'none';

    var galleryEl = document.createElement('div');
    galleryEl.className = 'combo-custom-gallery';

    var imgWrap = document.createElement('div');
    imgWrap.className = 'combo-custom-image-wrap';

    customImgEl = document.createElement('img');
    customImgEl.className = 'combo-custom-image';
    imgWrap.appendChild(customImgEl);

    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'combo-slide-arrow combo-slide-arrow--prev';
    prevBtn.setAttribute('aria-label', 'Előző kép');
    prevBtn.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0Z"/></svg>';
    prevBtn.addEventListener('click', function () { showImage(currentIndex - 1); });

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'combo-slide-arrow combo-slide-arrow--next';
    nextBtn.setAttribute('aria-label', 'Következő kép');
    nextBtn.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98Z"/></svg>';
    nextBtn.addEventListener('click', function () { showImage(currentIndex + 1); });

    galleryEl.appendChild(imgWrap);
    galleryEl.appendChild(prevBtn);
    galleryEl.appendChild(nextBtn);

    var touchStartX = null;
    imgWrap.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    imgWrap.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (dx > 40) showImage(currentIndex - 1);
      else if (dx < -40) showImage(currentIndex + 1);
      touchStartX = null;
    });

    wrapper.insertBefore(galleryEl, mainContainer);

    var thumbContainer = document.querySelector('.product__thumbs--scroller');
    if (thumbContainer) {
      thumbContainer.addEventListener('click', function (e) {
        var thumbEl = e.target.closest('[data-product-thumb]');
        if (!thumbEl) return;
        e.preventDefault();
        e.stopPropagation();
        var mediaId = thumbEl.getAttribute('data-id');
        var idx = currentVisibleList.findIndex(function (item) { return item.id === mediaId; });
        if (idx !== -1) showImage(idx);
      }, true);
    }

    galleryBuilt = true;
  }

  function updateComboFilter(options) {
    var colorVal = normalize(options.option1);
    var styleVal = normalize(options.option2);

    currentVisibleList = computeVisibleList(colorVal, styleVal);
    applyThumbFilter(currentVisibleList.map(function (item) { return item.id; }));

    var mainContainer = document.querySelector('[data-product-photos]');
    if (mainContainer) {
      buildGallery(mainContainer);
    }

    showImage(0);
  }

  window.ComboImageFilter = { update: updateComboFilter };

  document.addEventListener('variant:change', function (event) {
    if (event.detail && event.detail.variant) {
      updateComboFilter({
        option1: event.detail.variant.option1,
        option2: event.detail.variant.option2
      });
    }
  });
})();